$('.btn-getstart').click(function () {
  $('.sec1').addClass('our-flex');
  $('.sec1').addClass('w3-animate-right');
  $('.items-list').show();
  $('.firstscreen').hide();

});
$('.btn1-sec1').click(function() {
  $('.btn1-sec1').addClass('btn-quiz-active');
  $('.btn2-sec1').removeClass('btn-quiz-active');
  $('.btn1-sec1-next').prop('disabled', false);
});

$('.btn2-sec1').click(function() {
  $('.btn2-sec1').addClass('btn-quiz-active');
  $('.btn1-sec1').removeClass('btn-quiz-active');
  $('.btn1-sec1-next').prop('disabled', false);
});

$('.btn1-sec2').click(function() {
  $('.btn1-sec2').addClass('btn-quiz-active');
  $('.btn2-sec2').removeClass('btn-quiz-active');
  $('.btn3-sec2').removeClass('btn-quiz-active');
  $('.btn4-sec2').removeClass('btn-quiz-active');
  $('.btn5-sec2').removeClass('btn-quiz-active');
  $('.btn-sec2-next').prop('disabled', false);
});
$('.btn2-sec2').click(function() {
  $('.btn2-sec2').addClass('btn-quiz-active');
  $('.btn1-sec2').removeClass('btn-quiz-active');
  $('.btn3-sec2').removeClass('btn-quiz-active');
  $('.btn4-sec2').removeClass('btn-quiz-active');
  $('.btn5-sec2').removeClass('btn-quiz-active');
  $('.btn-sec2-next').prop('disabled', false);
});
$('.btn3-sec2').click(function() {
  $('.btn3-sec2').addClass('btn-quiz-active');
  $('.btn2-sec2').removeClass('btn-quiz-active');
  $('.btn1-sec2').removeClass('btn-quiz-active');
  $('.btn4-sec2').removeClass('btn-quiz-active');
  $('.btn5-sec2').removeClass('btn-quiz-active');
  $('.btn-sec2-next').prop('disabled', false);
});
$('.btn4-sec2').click(function() {
  $('.btn4-sec2').addClass('btn-quiz-active');
  $('.btn2-sec2').removeClass('btn-quiz-active');
  $('.btn3-sec2').removeClass('btn-quiz-active');
  $('.btn1-sec2').removeClass('btn-quiz-active');
  $('.btn5-sec2').removeClass('btn-quiz-active');
  $('.btn-sec2-next').prop('disabled', false);
});
$('.btn5-sec2').click(function() {
  $('.btn5-sec2').addClass('btn-quiz-active');
  $('.btn2-sec2').removeClass('btn-quiz-active');
  $('.btn3-sec2').removeClass('btn-quiz-active');
  $('.btn4-sec2').removeClass('btn-quiz-active');
  $('.btn1-sec2').removeClass('btn-quiz-active');
  $('.btn-sec2-next').prop('disabled', false);
});
$('.btn1-sec3').unbind("click").click(function() {
  $('.btn1-sec3').addClass('btn-quiz-active');
  $('.btn2-sec3').removeClass('btn-quiz-active');
  $('.btn3-sec3').removeClass('btn-quiz-active');
  $('.btn4-sec3').removeClass('btn-quiz-active');
  $('.btn-sec3-next').prop('disabled', false);
});
$('.btn2-sec3').click(function() {
  $('.btn2-sec3').addClass('btn-quiz-active');
  $('.btn1-sec3').removeClass('btn-quiz-active');
  $('.btn3-sec3').removeClass('btn-quiz-active');
  $('.btn4-sec3').removeClass('btn-quiz-active');
  $('.btn-sec3-next').prop('disabled', false);
});
$('.btn3-sec3').click(function() {
  $('.btn3-sec3').addClass('btn-quiz-active');
  $('.btn2-sec3').removeClass('btn-quiz-active');
  $('.btn1-sec3').removeClass('btn-quiz-active');
  $('.btn4-sec3').removeClass('btn-quiz-active');
  $('.btn-sec3-next').prop('disabled', false);
});
$('.btn4-sec3').click(function() {
  $('.btn4-sec3').addClass('btn-quiz-active');
  $('.btn2-sec3').removeClass('btn-quiz-active');
  $('.btn3-sec3').removeClass('btn-quiz-active');
  $('.btn1-sec3').removeClass('btn-quiz-active');
  $('.btn-sec3-next').prop('disabled', false);
});
$('.btn1-sec4').unbind("click").click(function() {
  $('.btn1-sec4').addClass('btn-quiz-active');
  $('.btn2-sec4').removeClass('btn-quiz-active');
  $('.btn3-sec4').removeClass('btn-quiz-active');
  $('.btn4-sec4').removeClass('btn-quiz-active');
  $('.btn5-sec4').removeClass('btn-quiz-active');
  $('.btn6-sec4').removeClass('btn-quiz-active');
  $('.btn-sec4-next').prop('disabled', false);
});
$('.btn2-sec4').click(function() {
  $('.btn2-sec4').addClass('btn-quiz-active');
  $('.btn1-sec4').removeClass('btn-quiz-active');
  $('.btn3-sec4').removeClass('btn-quiz-active');
  $('.btn4-sec4').removeClass('btn-quiz-active');
  $('.btn5-sec4').removeClass('btn-quiz-active');
  $('.btn6-sec4').removeClass('btn-quiz-active');
  $('.btn-sec4-next').prop('disabled', false);
});
$('.btn3-sec4').click(function() {
  $('.btn3-sec4').addClass('btn-quiz-active');
  $('.btn2-sec4').removeClass('btn-quiz-active');
  $('.btn1-sec4').removeClass('btn-quiz-active');
  $('.btn4-sec4').removeClass('btn-quiz-active');
  $('.btn5-sec4').removeClass('btn-quiz-active');
  $('.btn6-sec4').removeClass('btn-quiz-active');
  $('.btn-sec4-next').prop('disabled', false);
});
$('.btn4-sec4').click(function() {
  $('.btn4-sec4').addClass('btn-quiz-active');
  $('.btn2-sec4').removeClass('btn-quiz-active');
  $('.btn3-sec4').removeClass('btn-quiz-active');
  $('.btn1-sec4').removeClass('btn-quiz-active');
  $('.btn5-sec4').removeClass('btn-quiz-active');
  $('.btn6-sec4').removeClass('btn-quiz-active');
  $('.btn-sec4-next').prop('disabled', false);
});
$('.btn5-sec4').click(function() {
  $('.btn5-sec4').addClass('btn-quiz-active');
  $('.btn2-sec4').removeClass('btn-quiz-active');
  $('.btn3-sec4').removeClass('btn-quiz-active');
  $('.btn4-sec4').removeClass('btn-quiz-active');
  $('.btn1-sec4').removeClass('btn-quiz-active');
  $('.btn6-sec4').removeClass('btn-quiz-active');
  $('.btn-sec4-next').prop('disabled', false);
});
$('.btn6-sec4').click(function() {
  $('.btn6-sec4').addClass('btn-quiz-active');
  $('.btn2-sec4').removeClass('btn-quiz-active');
  $('.btn3-sec4').removeClass('btn-quiz-active');
  $('.btn4-sec4').removeClass('btn-quiz-active');
  $('.btn5-sec4').removeClass('btn-quiz-active');
  $('.btn1-sec4').removeClass('btn-quiz-active');
  $('.btn-sec4-next').prop('disabled', false);
});
$('.btn1-sec5').click(function() {
  $('.btn1-sec5').addClass('btn-quiz-active');
  $('.btn2-sec5').removeClass('btn-quiz-active');
  $('.btn3-sec5').removeClass('btn-quiz-active');
  $('.btn-sec5-next').prop('disabled', false);
});
$('.btn2-sec5').click(function() {
  $('.btn2-sec5').addClass('btn-quiz-active');
  $('.btn1-sec5').removeClass('btn-quiz-active');
  $('.btn3-sec5').removeClass('btn-quiz-active');
  $('.btn-sec5-next').prop('disabled', false);
});
$('.btn3-sec5').click(function() {
  $('.btn3-sec5').addClass('btn-quiz-active');
  $('.btn2-sec5').removeClass('btn-quiz-active');
  $('.btn1-sec5').removeClass('btn-quiz-active');
  $('.btn-sec5-next').prop('disabled', false);
});
$('.btn1-sec6').click(function() {
  $('.btn1-sec6').addClass('btn-quiz-active');
  $('.btn2-sec6').removeClass('btn-quiz-active');
  $('.btn3-sec6').removeClass('btn-quiz-active');
  $('.btn-sec6-next').prop('disabled', false);
});
$('.btn2-sec6').click(function() {
  $('.btn2-sec6').addClass('btn-quiz-active');
  $('.btn1-sec6').removeClass('btn-quiz-active');
  $('.btn3-sec6').removeClass('btn-quiz-active');
  $('.btn-sec6-next').prop('disabled', false);
});
$('.btn3-sec6').click(function() {
  $('.btn3-sec6').addClass('btn-quiz-active');
  $('.btn2-sec6').removeClass('btn-quiz-active');
  $('.btn1-sec6').removeClass('btn-quiz-active');
  $('.btn-sec6-next').prop('disabled', false);
});



//next button js
$('.btn1-sec1-next').click(function (){
  $('.sec2').addClass('our-flex');
  $('.sec2').addClass('w3-animate-right');
  $('.sec1').removeClass('our-flex');
  $('.li-item-css2').addClass('.active');
  $('.li-item-css1').removeClass('.active');
});

$('.btn-sec2-next').click(function (){
  $('.sec3').addClass('our-flex');
  $('.sec3').addClass('w3-animate-right');
  $('.sec2').removeClass('our-flex');
  $('.li-item-css2').addClass('.active');
  $('.li-item-css1').removeClass('.active');
});

$('.btn-sec3-next').click(function (){
  $('.sec4').addClass('our-flex');
  $('.sec4').addClass('w3-animate-right');
  $('.sec3').removeClass('our-flex');
  $('.li-item-css2').addClass('.active');
  $('.li-item-css1').removeClass('.active');
});

$('.btn-sec4-next').click(function (){
  $('.sec5').addClass('our-flex');
  $('.sec5').addClass('w3-animate-right');
  $('.sec4').removeClass('our-flex');
  $('.li-item-css2').addClass('.active');
  $('.li-item-css1').removeClass('.active');
});

$('.btn-sec5-next').click(function (){
  $('.sec6').addClass('our-flex');
  $('.sec6').addClass('w3-animate-right');
  $('.sec5').removeClass('our-flex');
  $('.li-item-css2').addClass('.active');
  $('.li-item-css1').removeClass('.active');
});

$('.btn-sec6-next').click(function (){
  $('.sec7').addClass('our-flex');
  $('.sec7').addClass('w3-animate-right');
  $('.sec6').removeClass('our-flex');
  $('.li-item-css2').addClass('.active');
  $('.li-item-css1').removeClass('.active');
});

items = [];
oilycheck = false;
oilinessporescheck = false;
drycheck = false;
normalcheck = false;
combinationcheck = false;
acnepimplescheck = false;
acnescarscheck = false;
unevenskintonecheck = false;
darkspotscheck = false;
dulldryskincheck = false;


function storeVar(el){
  var amount = el.value;
  console.log(el.value);

  if(el.value == 'oily' ){
    oilycheck = true;
  }
  else if(el.value == 'oilinesspores'){
    oilinessporescheck = true;
  }
  else if(el.value == 'dry' ){
    drycheck = true;
  }
  else if(el.value == 'normal'){
    normalcheck = true;
  }
  else if(el.value == 'combination' ){
    combinationcheck = true;
  }
  else if(el.value == 'acnepimples' ){
    acnepimplescheck = true;
  }
  else if(el.value == 'acnescars'){
    acnescarscheck = true;
  }
  else if(el.value == 'unevenskintone'){
    unevenskintonecheck = true;
  }
  else if(el.value == 'darkspots'){
    darkspotscheck = true;
  }
  else if(el.value == 'dulldryskin'){
    dulldryskincheck = true;
  }


  $('.unselecttext1').click(function (){
    $('.removetext1').show();
    $('.unselecttext1').css('display', 'none');
    $('.btnremovetext1').css('display', 'none');
  });

  $('.unselecttext2').click(function (){
    $('.removetext2').show();
    $('.unselecttext2').css('display', 'none');
    $('.btnremovetext2').css('display', 'none');
  });

  $('.unselecttext3').click(function (){
    $('.removetext3').show();
    $('.unselecttext3').css('display', 'none');
    $('.btnremovetext3').css('display', 'none');
  });

  $('.unselecttext4').click(function (){
    $('.removetext4').show();
    $('.unselecttext4').css('display', 'none');
    $('.btnremovetext4').css('display', 'none');
  });
  $('.unselecttext5').click(function (){
    $('.removetext5').show();
    $('.unselecttext5').css('display', 'none');
    $('.btnremovetext5').css('display', 'none');
  });

  $('.unselecttext6').click(function (){
    $('.removetext6').show();
    $('.unselecttext6').css('display', 'none');
    $('.btnremovetext6').css('display', 'none');
  });

  $('.unselecttext7').click(function (){
    $('.removetext7').show();
    $('.unselecttext7').css('display', 'none');
    $('.btnremovetext7').css('display', 'none');
  });

  $('.unselecttext8').click(function (){
    $('.removetext8').show();
    $('.unselecttext8').css('display', 'none');
    $('.btnremovetext8').css('display', 'none');
  });

  $('.unselecttext9').click(function (){
    $('.removetext9').show();
    $('.unselecttext9').css('display', 'none');
    $('.btnremovetext9').css('display', 'none');
  });

  $('.unselecttext10').click(function (){
    $('.removetext10').show();
    $('.unselecttext10').css('display', 'none');
    $('.btnremovetext10').css('display', 'none');
  });

  $('.unselecttext11').click(function (){
    $('.removetext11').show();
    $('.unselecttext11').css('display', 'none');
    $('.btnremovetext11').css('display', 'none');
  });

  $('.unselecttext12').click(function (){
    $('.removetext12').show();
    $('.unselecttext12').css('display', 'none');
    $('.btnremovetext12').css('display', 'none');
  });

  $('.unselecttext13').click(function (){
    $('.removetext13').show();
    $('.unselecttext13').css('display', 'none');
    $('.btnremovetext13').css('display', 'none');
  });

  $('.unselecttext14').click(function (){
    $('.removetext14').show();
    $('.unselecttext14').css('display', 'none');
    $('.btnremovetext14').css('display', 'none');
  });

  $('.unselecttext15').click(function (){
    $('.removetext15').show();
    $('.unselecttext15').css('display', 'none');
    $('.btnremovetext15').css('display', 'none');
  });

  $('.unselecttext16').click(function (){
    $('.removetext16').show();
    $('.unselecttext16').css('display', 'none');
    $('.btnremovetext16').css('display', 'none');
  });

  $('.unselecttext17').click(function (){
    $('.removetext17').show();
    $('.unselecttext17').css('display', 'none');
    $('.btnremovetext17').css('display', 'none');
  });

  $('.unselecttext18').click(function (){
    $('.removetext18').show();
    $('.unselecttext18').css('display', 'none');
    $('.btnremovetext18').css('display', 'none');
  });

  $('.unselecttext19').click(function (){
    $('.removetext19').show();
    $('.unselecttext19').css('display', 'none');
    $('.btnremovetext19').css('display', 'none');
  });

  $('.unselecttext20').click(function (){
    $('.removetext20').show();
    $('.unselecttext20').css('display', 'none');
    $('.btnremovetext20').css('display', 'none');
  });

  $('.unselecttext21').click(function (){
    $('.removetext21').show();
    $('.unselecttext21').css('display', 'none');
    $('.btnremovetext21').css('display', 'none');
  });

  $('.unselecttext22').click(function (){
    $('.removetext22').show();
    $('.unselecttext22').css('display', 'none');
    $('.btnremovetext22').css('display', 'none');
  });

  $('.unselecttext23').click(function (){
    $('.removetext23').show();
    $('.unselecttext23').css('display', 'none');
    $('.btnremovetext23').css('display', 'none');
  });

  $('.unselecttext24').click(function (){
    $('.removetext24').show();
    $('.unselecttext24').css('display', 'none');
    $('.btnremovetext24').css('display', 'none');
  });

  $('.unselecttext25').click(function (){
    $('.removetext25').show();
    $('.unselecttext25').css('display', 'none');
    $('.btnremovetext25').css('display', 'none');
  });

  $('.unselecttext26').click(function (){
    $('.removetext26').show();
    $('.unselecttext26').css('display', 'none');
    $('.btnremovetext26').css('display', 'none');
  });

  $('.unselecttext27').click(function (){
    $('.removetext27').show();
    $('.unselecttext27').css('display', 'none');
    $('.btnremovetext27').css('display', 'none');
  });

  $('.unselecttext28').click(function (){
    $('.removetext28').show();
    $('.unselecttext28').css('display', 'none');
    $('.btnremovetext28').css('display', 'none');
  });

  $('.unselecttext29').click(function (){
    $('.removetext29').show();
    $('.unselecttext29').css('display', 'none');
    $('.btnremovetext29').css('display', 'none');
  });

  $('.unselecttext30').click(function (){
    $('.removetext30').show();
    $('.unselecttext30').css('display', 'none');
    $('.btnremovetext30').css('display', 'none');
  });

  $('.unselecttext31').click(function (){
    $('.removetext31').show();
    $('.unselecttext31').css('display', 'none');
    $('.btnremovetext31').css('display', 'none');
  });

  $('.unselecttext32').click(function (){
    $('.removetext32').show();
    $('.unselecttext32').css('display', 'none');
    $('.btnremovetext32').css('display', 'none');
  });

  $('.unselecttext33').click(function (){
    $('.removetext33').show();
    $('.unselecttext33').css('display', 'none');
    $('.btnremovetext33').css('display', 'none');
  });

  $('.unselecttext34').click(function (){
    $('.removetext34').show();
    $('.unselecttext34').css('display', 'none');
    $('.btnremovetext34').css('display', 'none');
  });

  $('.unselecttext35').click(function (){
    $('.removetext35').show();
    $('.unselecttext35').css('display', 'none');
    $('.btnremovetext35').css('display', 'none');
  });

  $('.unselecttext36').click(function (){
    $('.removetext36').show();
    $('.unselecttext36').css('display', 'none');
    $('.btnremovetext36').css('display', 'none');
  });

  $('.unselecttext37').click(function (){
    $('.removetext37').show();
    $('.unselecttext37').css('display', 'none');
    $('.btnremovetext37').css('display', 'none');
  });

  $('.unselecttext38').click(function (){
    $('.removetext38').show();
    $('.unselecttext38').css('display', 'none');
    $('.btnremovetext38').css('display', 'none');
  });

  $('.unselecttext39').click(function (){
    $('.removetext39').show();
    $('.unselecttext39').css('display', 'none');
    $('.btnremovetext39').css('display', 'none');
  });

  $('.unselecttext40').click(function (){
    $('.removetext40').show();
    $('.unselecttext40').css('display', 'none');
    $('.btnremovetext40').css('display', 'none');
  });

  $('.unselecttext41').click(function (){
    $('.removetext42').show();
    $('.unselecttext43').css('display', 'none');
    $('.btnremovetext44').css('display', 'none');
  });

  $('.unselecttext45').click(function (){
    $('.removetext45').show();
    $('.unselecttext45').css('display', 'none');
    $('.btnremovetext45').css('display', 'none');
  });

  $('.unselecttext46').click(function (){
    $('.removetext46').show();
    $('.unselecttext46').css('display', 'none');
    $('.btnremovetext46').css('display', 'none');
  });

  $('.unselecttext47').click(function (){
    $('.removetext47').show();
    $('.unselecttext47').css('display', 'none');
    $('.btnremovetext47').css('display', 'none');
  });

  $('.unselecttext48').click(function (){
    $('.removetext48').show();
    $('.unselecttext48').css('display', 'none');
    $('.btnremovetext48').css('display', 'none');
  });

  $('.unselecttext49').click(function (){
    $('.removetext49').show();
    $('.unselecttext49').css('display', 'none');
    $('.btnremovetext49').css('display', 'none');
  });

  $('.unselecttext50').click(function (){
    $('.removetext50').show();
    $('.unselecttext50').css('display', 'none');
    $('.btnremovetext50').css('display', 'none');
  });

  $('.unselecttext51').click(function (){
    $('.removetext51').show();
    $('.unselecttext51').css('display', 'none');
    $('.btnremovetext51').css('display', 'none');
  });

  $('.unselecttext52').click(function (){
    $('.removetext52').show();
    $('.unselecttext52').css('display', 'none');
    $('.btnremovetext52').css('display', 'none');
  });

  $('.unselecttext53').click(function (){
    $('.removetext53').show();
    $('.unselecttext53').css('display', 'none');
    $('.btnremovetext53').css('display', 'none');
  });

  $('.unselecttext54').click(function (){
    $('.removetext54').show();
    $('.unselecttext54').css('display', 'none');
    $('.btnremovetext54').css('display', 'none');
  });

  $('.unselecttext55').click(function (){
    $('.removetext55').show();
    $('.unselecttext55').css('display', 'none');
    $('.btnremovetext55').css('display', 'none');
  });

  $('.unselecttext56').click(function (){
    $('.removetext56').show();
    $('.unselecttext56').css('display', 'none');
    $('.btnremovetext56').css('display', 'none');
  });

  $('.unselecttext57').click(function (){
    $('.removetext57').show();
    $('.unselecttext57').css('display', 'none');
    $('.btnremovetext57').css('display', 'none');
  });

  $('.unselecttext58').click(function (){
    $('.removetext58').show();
    $('.unselecttext58').css('display', 'none');
    $('.btnremovetext58').css('display', 'none');
  });

  $('.unselecttext59').click(function (){
    $('.removetext59').show();
    $('.unselecttext59').css('display', 'none');
    $('.btnremovetext59').css('display', 'none');
  });

  $('.unselecttext60').click(function (){
    $('.removetext60').show();
    $('.unselecttext60').css('display', 'none');
    $('.btnremovetext60').css('display', 'none');
  });

  $('.unselecttext61').click(function (){
    $('.removetext61').show();
    $('.unselecttext61').css('display', 'none');
    $('.btnremovetext61').css('display', 'none');
  });

  $('.unselecttext62').click(function (){
    $('.removetext62').show();
    $('.unselecttext62').css('display', 'none');
    $('.btnremovetext62').css('display', 'none');
  });

  $('.unselecttext63').click(function (){
    $('.removetext63').show();
    $('.unselecttext63').css('display', 'none');
    $('.btnremovetext63').css('display', 'none');
  });

  $('.unselecttext64').click(function (){
    $('.removetext64').show();
    $('.unselecttext64').css('display', 'none');
    $('.btnremovetext64').css('display', 'none');
  });

  $('.unselecttext65').click(function (){
    $('.removetext65').show();
    $('.unselecttext65').css('display', 'none');
    $('.btnremovetext65').css('display', 'none');
  });

  $('.unselecttext66').click(function (){
    $('.removetext66').show();
    $('.unselecttext66').css('display', 'none');
    $('.btnremovetext66').css('display', 'none');
  });

  $('.unselecttext67').click(function (){
    $('.removetext67').show();
    $('.unselecttext67').css('display', 'none');
    $('.btnremovetext67').css('display', 'none');
  });

  $('.unselecttext68').click(function (){
    $('.removetext68').show();
    $('.unselecttext68').css('display', 'none');
    $('.btnremovetext68').css('display', 'none');
  });

  $('.unselecttext69').click(function (){
    $('.removetext69').show();
    $('.unselecttext69').css('display', 'none');
    $('.btnremovetext69').css('display', 'none');
  });

  $('.unselecttext70').click(function (){
    $('.removetext70').show();
    $('.unselecttext70').css('display', 'none');
    $('.btnremovetext70').css('display', 'none');
  });

  $('.unselecttext71').click(function (){
    $('.removetext71').show();
    $('.unselecttext71').css('display', 'none');
    $('.btnremovetext71').css('display', 'none');
  });

  $('.unselecttext72').click(function (){
    $('.removetext72').show();
    $('.unselecttext72').css('display', 'none');
    $('.btnremovetext72').css('display', 'none');
  });

  $('.unselecttext73').click(function (){
    $('.removetext73').show();
    $('.unselecttext73').css('display', 'none');
    $('.btnremovetext73').css('display', 'none');
  });

  $('.unselecttext74').click(function (){
    $('.removetext74').show();
    $('.unselecttext74').css('display', 'none');
    $('.btnremovetext74').css('display', 'none');
  });

  $('.unselecttext75').click(function (){
    $('.removetext75').show();
    $('.unselecttext75').css('display', 'none');
    $('.btnremovetext75').css('display', 'none');
  });

  $('.unselecttext76').click(function (){
    $('.removetext76').show();
    $('.unselecttext76').css('display', 'none');
    $('.btnremovetext76').css('display', 'none');
  });

  $('.unselecttext77').click(function (){
    $('.removetext77').show();
    $('.unselecttext77').css('display', 'none');
    $('.btnremovetext77').css('display', 'none');
  });

  $('.unselecttext78').click(function (){
    $('.removetext78').show();
    $('.unselecttext78').css('display', 'none');
    $('.btnremovetext78').css('display', 'none');
  });

  $('.unselecttext79').click(function (){
    $('.removetext79').show();
    $('.unselecttext79').css('display', 'none');
    $('.btnremovetext79').css('display', 'none');
  });

  $('.unselecttext80').click(function (){
    $('.removetext80').show();
    $('.unselecttext80').css('display', 'none');
    $('.btnremovetext80').css('display', 'none');
  });

  $('.unselecttext81').click(function (){
    $('.removetext81').show();
    $('.unselecttext81').css('display', 'none');
    $('.btnremovetext81').css('display', 'none');
  });

  $('.unselecttext82').click(function (){
    $('.removetext82').show();
    $('.unselecttext82').css('display', 'none');
    $('.btnremovetext82').css('display', 'none');
  });

  $('.unselecttext83').click(function (){
    $('.removetext83').show();
    $('.unselecttext83').css('display', 'none');
    $('.btnremovetext83').css('display', 'none');
  });

  $('.unselecttext84').click(function (){
    $('.removetext84').show();
    $('.unselecttext84').css('display', 'none');
    $('.btnremovetext84').css('display', 'none');
  });

  $('.unselecttext85').click(function (){
    $('.removetext85').show();
    $('.unselecttext85').css('display', 'none');
    $('.btnremovetext85').css('display', 'none');
  });

  $('.unselecttext86').click(function (){
    $('.removetext86').show();
    $('.unselecttext86').css('display', 'none');
    $('.btnremovetext86').css('display', 'none');
  });

  $('.unselecttext87').click(function (){
    $('.removetext87').show();
    $('.unselecttext87').css('display', 'none');
    $('.btnremovetext87').css('display', 'none');
  });

  $('.unselecttext88').click(function (){
    $('.removetext88').show();
    $('.unselecttext88').css('display', 'none');
    $('.btnremovetext88').css('display', 'none');
  });

  $('.unselecttext89').click(function (){
    $('.removetext89').show();
    $('.unselecttext89').css('display', 'none');
    $('.btnremovetext89').css('display', 'none');
  });

  $('.unselecttext90').click(function (){
    $('.removetext90').show();
    $('.unselecttext90').css('display', 'none');
    $('.btnremovetext90').css('display', 'none');
  });



  //removebtn section 


  if(el.value == 'removebtn1' ){
    items = items.filter(item => item.id !== 40394279616572);
  }

  else if(el.value == 'removebtn2' ){
    items = items.filter(item => item.id !== 40394279551036);
  }

  else if(el.value == 'removebtn3' ){
    items = items.filter(item => item.id !==40394279190588);
  }
  else if(el.value == 'removebtn4' ){
    items = items.filter(item => item.id != "40394279518268");
    console.log(items);
  }
  else if(el.value == 'removebtn5' ){
    items = items.filter(item => item.id !== 40394279616572);
  }
  else if(el.value == 'removebtn6' ){
    items = items.filter(item => item.id !== 40394279551036);
  }
  else if(el.value == 'removebtn7' ){
    items = items.filter(item => item.id !==40394279190588);
  }
  else if(el.value == 'removebtn8' ){
    items = items.filter(item => item.id !== 40394279518268);
  }
  else if(el.value == 'removebtn9' ){
    items = items.filter(item => item.id !== 40394279452732);
  }
  else if(el.value == 'removebtn10' ){
    items = items.filter(item => item.id !== 40394279911484);
  }
  else if(el.value == 'removebtn11' ){
    items = items.filter(item => item.id !== 40394279649340);
  }
  else if(el.value == 'removebtn12' ){
    items = items.filter(item => item.id !==40394279190588);
  }
  else if(el.value == 'removebtn13' ){
    items = items.filter(item => item.id !== 40394279518268);
  }
  else if(el.value == 'removebtn14' ){
    items = items.filter(item => item.id !== 40394279452732);
  }
  else if(el.value == 'removebtn15' ){
    items = items.filter(item => item.id !== 40394279911484);
  }
  else if(el.value == 'removebtn16' ){
    items = items.filter(item => item.id !== 40394279551036);
  }
  else if(el.value == 'removebtn17' ){
    items = items.filter(item => item.id !== 40394279649340);
  }
  else if(el.value == 'removebtn18' ){
    items = items.filter(item => item.id !==40394279190588);
  }
  else if(el.value == 'removebtn19' ){
    items = items.filter(item => item.id !== 40394279518268);
  }
  else if(el.value == 'removebtn20' ){
    items = items.filter(item => item.id !== 40394279452732);
  }
  else if(el.value == 'removebtn21' ){
    items = items.filter(item => item.id !== 40394279911484);
  }
  else if(el.value == 'removebtn22' ){
    items = items.filter(item => item.id !== 40394279649340);
  }
  else if(el.value == 'removebtn23' ){
    items = items.filter(item => item.id !==40394279190588);
  }
  else if(el.value == 'removebtn24' ){
    items = items.filter(item => item.id !== 40394279518268);
  }
  else if(el.value == 'removebtn25' ){
    items = items.filter(item => item.id !== 40394279616572);
  }
  else if(el.value == 'removebtn26' ){
    items = items.filter(item => item.id !== 40394279551036);
  }
  else if(el.value == 'removebtn27' ){
    items = items.filter(item => item.id !==40394279190588);
  }
  else if(el.value == 'removebtn28' ){
    items = items.filter(item => item.id !== 39352889737276);
  }
  else if(el.value == 'removebtn29' ){
    items = items.filter(item => item.id !== 40394279616572);
  }
  else if(el.value == 'removebtn30' ){
    items = items.filter(item => item.id !== 40394279157820);
  }
  else if(el.value == 'removebtn31' ){
    items = items.filter(item => item.id !==40394279190588);
  }
  else if(el.value == 'removebtn32' ){
    items = items.filter(item => item.id !== 39352889737276);
  }
  else if(el.value == 'removebtn33' ){
    items = items.filter(item => item.id !== 40394279452732);
  }
  else if(el.value == 'removebtn34' ){
    items = items.filter(item => item.id !== 40394279616572);
  }
  else if(el.value == 'removebtn35' ){
    items = items.filter(item => item.id !== 40394279649340);
  }
  else if(el.value == 'removebtn36' ){
    items = items.filter(item => item.id !==40394279190588);
  }
  else if(el.value == 'removebtn37' ){
    items = items.filter(item => item.id !== 39352889737276);
  }
  else if(el.value == 'removebtn38' ){
    items = items.filter(item => item.id !== 40394279452732);
  }
  else if(el.value == 'removebtn39' ){
    items = items.filter(item => item.id !== 40394279616572);
  }
  else if(el.value == 'removebtn40' ){
    items = items.filter(item => item.id !== 40394279649340);
  }
  else if(el.value == 'removebtn41' ){
    items = items.filter(item => item.id !== 39352859820092);
  }
  else if(el.value == 'removebtn42' ){
    items = items.filter(item => item.id !== 39352889737276);
  }
  else if(el.value == 'removebtn43' ){
    items = items.filter(item => item.id !== 40394279452732);
  }
  else if(el.value == 'removebtn44' ){
    items = items.filter(item => item.id !== 40394279616572);
  }
  else if(el.value == 'removebtn45' ){
    items = items.filter(item => item.id !== 40394279551036);
  }
  else if(el.value == 'removebtn46' ){
    items = items.filter(item => item.id !==40394279190588);
  }
  else if(el.value == 'removebtn47' ){
    items = items.filter(item => item.id !== 40394279485500);
  }
  else if(el.value == 'removebtn48' ){
    items = items.filter(item => item.id !== 40394279452732);
  }
  else if(el.value == 'removebtn49' ){
    items = items.filter(item => item.id !== 40394279911484);
  }
  else if(el.value == 'removebtn50' ){
    items = items.filter(item => item.id !== 40394279649340);
  }
  else if(el.value == 'removebtn51' ){
    items = items.filter(item => item.id !==40394279190588);
  }
  else if(el.value == 'removebtn52' ){
    items = items.filter(item => item.id !== 40394279485500);
  }
  else if(el.value == 'removebtn53' ){
    items = items.filter(item => item.id !== 40394279452732);
  }
  else if(el.value == 'removebtn54' ){
    items = items.filter(item => item.id !== 40394279911484);
  }
  else if(el.value == 'removebtn55' ){
    items = items.filter(item => item.id !== 40394279649340);
  }
  else if(el.value == 'removebtn56' ){
    items = items.filter(item => item.id !== 40394279551036);
  }
  else if(el.value == 'removebtn57' ){
    items = items.filter(item => item.id !==40394279190588);
  }
  else if(el.value == 'removebtn58' ){
    items = items.filter(item => item.id !== 40394279485500);
  }
  else if(el.value == 'removebtn59' ){
    items = items.filter(item => item.id !== 40394279452732);
  }
  else if(el.value == 'removebtn60' ){
    items = items.filter(item => item.id !== 40394279616572);
  }
  else if(el.value == 'removebtn61' ){
    items = items.filter(item => item.id !== 40394279649340);
  }
  else if(el.value == 'removebtn62' ){
    items = items.filter(item => item.id !== 39352859820092);
  }
  else if(el.value == 'removebtn63' ){
    items = items.filter(item => item.id !== 40394279485500);
  }
  else if(el.value == 'removebtn64' ){
    items = items.filter(item => item.id !== 40394279452732);
  }
  else if(el.value == 'removebtn65' ){
    items = items.filter(item => item.id !== 40394279616572);
  }
  else if(el.value == 'removebtn66' ){
    items = items.filter(item => item.id !== 40394279551036);
  }
  else if(el.value == 'removebtn67' ){
    items = items.filter(item => item.id !==40394279190588);
  }
  else if(el.value == 'removebtn68' ){
    items = items.filter(item => item.id !== 40394279518268);
  }
  else if(el.value == 'removebtn69' ){
    items = items.filter(item => item.id !== 40394279616572);
  }
  else if(el.value == 'removebtn70' ){
    items = items.filter(item => item.id !== 40394279551036);
  }
  else if(el.value == 'removebtn71' ){
    items = items.filter(item => item.id !==40394279190588);
  }
  else if(el.value == 'removebtn72' ){
    items = items.filter(item => item.id !== 40394279518268);
  }
  else if(el.value == 'removebtn73' ){
    items = items.filter(item => item.id !== 40394279452732);
  }
  else if(el.value == 'removebtn74' ){
    items = items.filter(item => item.id !== 40394279911484);
  }
  else if(el.value == 'removebtn75' ){
    items = items.filter(item => item.id !== 40394279649340);
  }
  else if(el.value == 'removebtn76' ){
    items = items.filter(item => item.id !==40394279190588);
  }
  else if(el.value == 'removebtn77' ){
    items = items.filter(item => item.id !== 39352889737276);
  }
  else if(el.value == 'removebtn78' ){
    items = items.filter(item => item.id !== 40394279452732);
  }
  else if(el.value == 'removebtn79' ){
    items = items.filter(item => item.id !== 40394279616572);
  }
  else if(el.value == 'removebtn80' ){
    items = items.filter(item => item.id !== 40394279649340);
  }
  else if(el.value == 'removebtn81' ){
    items = items.filter(item => item.id !== 40394279551036);
  }
  else if(el.value == 'removebtn82' ){
    items = items.filter(item => item.id !==40394279190588);
  }
  else if(el.value == 'removebtn83' ){
    items = items.filter(item => item.id !== 40394279485500);
  }
  else if(el.value == 'removebtn84' ){
    items = items.filter(item => item.id !== 40394279452732);
  }
  else if(el.value == 'removebtn85' ){
    items = items.filter(item => item.id !== 40394279616572);
  }
  else if(el.value == 'removebtn86' ){
    items = items.filter(item => item.id !== 40394279649340);
  }
  else if(el.value == 'removebtn87' ){
    items = items.filter(item => item.id !== 39352859820092);
  }
  else if(el.value == 'removebtn88' ){
    items = items.filter(item => item.id !== 39352889737276);
  }
  else if(el.value == 'removebtn89' ){
    items = items.filter(item => item.id !== 40394279452732);
  }



  //with oily check
  if(oilycheck === true && oilinessporescheck === true){
    items.push({
      id: 40394279616572, 
      quantity: 1
    },
               {
      id: 40394279551036, 
      quantity: 1
    },
               {
      id:40394279190588, 
      quantity: 1
    },
               {
      id: 40394279518268,
      quantity: 1
    }
              )

    $('.container1-sec1').show();
    $('.container2-sec2').hide();
    $('.container3-sec3').hide();
    $('.container4-sec4').hide();
    $('.container5-sec5').hide();
    $('.container6-sec6').hide();
    $('.container7-sec7').hide();
    $('.container8-sec8').hide();
    $('.container81-sec81').hide();
    $('.container9-sec9').hide();
    $('.container10-sec10').hide();
    $('.container11-sec11').hide();
    $('.container12-sec12').hide();
    $('.container13-sec13').hide();
    $('.container14-sec14').hide();
    $('.container15-sec15').hide();
    $('.container16-sec16').hide();
    $('.container17-sec17').hide();


    /* var c1i1 = document.getElementById('container1-item1');
    var c1i2 = document.getElementById('container1-item2');
    var c1i3 = document.getElementById('container1-item3');
    var c1i4 = document.getElementById('container1-item4');
    c1i1.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/mandelaac-FW.jpg?v=1628249957" ></img>' ;
    c1i1.innerHTML += '<h3 class="mbl-heading-size">MandelAC Facewash</h3>';

    c1i2.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/Mandelac-Serum_2_0b071a3e-3248-41ff-be3b-24804c281f85.jpg?v=1628373009" ></img>';
    c1i2.innerHTML += '<h3 class="mbl-heading-size">MANDELAC SERUM</h3>';

    c1i3.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/Dermive-Oil-Free_2_9336c317-339d-4fc0-a5db-dda3ad66786f.jpg?v=1628373012" ></img>';
    c1i3.innerHTML += '<h3 class="mbl-heading-size">Dermive Oil Free</h3>';

    c1i4.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/spectyra-Matt.jpg?v=1628756247" ></img>';
    c1i4.innerHTML += '<h3 class="mbl-heading-size">SPECTRA Matt SC SPF 40</h3>';
  */
  }

  else if(oilycheck === true && acnepimplescheck === true){
    items.push({
      id: 40394279616572, 
      quantity: 1
    },
               {
      id: 40394279551036, 
      quantity: 1
    },
               {
      id:40394279190588, 
      quantity: 1
    },
               {
      id: 40394279518268,
      quantity: 1
    },
               {
      id: 40394279452732,
      quantity: 1
    }
              )

    $('.container2-sec2').show();
    $('.container1-sec1').hide();
    $('.container3-sec3').hide();
    $('.container4-sec4').hide();
    $('.container5-sec5').hide();
    $('.container6-sec6').hide();
    $('.container7-sec7').hide();
    $('.container8-sec8').hide();
    $('.container81-sec81').hide();
    $('.container9-sec9').hide();
    $('.container10-sec10').hide();
    $('.container11-sec11').hide();
    $('.container12-sec12').hide();
    $('.container13-sec13').hide();
    $('.container14-sec14').hide();
    $('.container15-sec15').hide();
    $('.container16-sec16').hide();
    $('.container17-sec17').hide();

    /*
    var c2i1 = document.getElementById('container2-item1');
    var c2i2 = document.getElementById('container2-item2');
    var c2i3 = document.getElementById('container2-item3');
    var c2i4 = document.getElementById('container2-item4');
    var c2i5 = document.getElementById('container2-item5');

    c2i1.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/mandelaac-FW.jpg?v=1628249957" ></img>';
    c2i1.innerHTML += '<h3 class="mbl-heading-size">MandelAC Facewash</h3>';

    c2i2.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/Mandelac-Serum_2_0b071a3e-3248-41ff-be3b-24804c281f85.jpg?v=1628373009" ></img>';
    c2i2.innerHTML += '<h3 class="mbl-heading-size">MANDELAC SERUM</h3>';

    c2i3.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/Dermive-Oil-Free_2_9336c317-339d-4fc0-a5db-dda3ad66786f.jpg?v=1628373012" ></img>';
    c2i3.innerHTML += '<h3 class="mbl-heading-size">Dermive Oil Free</h3>';

    c2i4.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/spectyra-Matt.jpg?v=1628756247" ></img>';
    c2i4.innerHTML += '<h3 class="mbl-heading-size">SPECTRA Matt SC SPF 40</h3>';

    c2i5.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/revivoderm_2.jpg?v=1628372474" ></img>';
    c2i5.innerHTML += '<h3 class="mbl-heading-size">REVIVODERM</h3>';
  */

  }
  else if(oilycheck === true && acnescarscheck === true){
    items.push({
      id: 40394279616572,
      quantity: 1
    },
               {
      id: 40394279551036,
      quantity: 1
    },
               {
      id:40394279190588,
      quantity: 1
    },
               {
      id: 40394279518268,
      quantity: 1
    },
               {
      id: 40394279452732,
      quantity: 1
    }
              )


    $('.container2-sec2').show();
    $('.container1-sec1').hide();
    $('.container3-sec3').hide();
    $('.container4-sec4').hide();
    $('.container5-sec5').hide();
    $('.container6-sec6').hide();
    $('.container7-sec7').hide();
    $('.container8-sec8').hide();
    $('.container81-sec81').hide();
    $('.container9-sec9').hide();
    $('.container10-sec10').hide();
    $('.container11-sec11').hide();
    $('.container12-sec12').hide();
    $('.container13-sec13').hide();
    $('.container14-sec14').hide();
    $('.container15-sec15').hide();
    $('.container16-sec16').hide();
    $('.container17-sec17').hide();


    /*
    var c2i1 = document.getElementById('container2-item1');
    var c2i2 = document.getElementById('container2-item2');
    var c2i3 = document.getElementById('container2-item3');
    var c2i4 = document.getElementById('container2-item4');
    var c2i5 = document.getElementById('container2-item5');

    c2i1.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/mandelaac-FW.jpg?v=1628249957" ></img>';
    c2i1.innerHTML += '<h3 class="mbl-heading-size">MandelAC Facewash</h3>';

    c2i2.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/Mandelac-Serum_2_0b071a3e-3248-41ff-be3b-24804c281f85.jpg?v=1628373009" ></img>';
    c2i2.innerHTML += '<h3 class="mbl-heading-size">MANDELAC SERUM</h3>';

    c2i3.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/Dermive-Oil-Free_2_9336c317-339d-4fc0-a5db-dda3ad66786f.jpg?v=1628373012" ></img>';
    c2i3.innerHTML += '<h3 class="mbl-heading-size">Dermive Oil Free</h3>';

    c2i4.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/spectyra-Matt.jpg?v=1628756247" ></img>';
    c2i4.innerHTML += '<h3 class="mbl-heading-size">SPECTRA Matt SC SPF 40</h3>';

    c2i5.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/revivoderm_2.jpg?v=1628372474" ></img>';
    c2i5.innerHTML += '<h3 class="mbl-heading-size">REVIVODERM</h3>';  
  */

  }
  else if(oilycheck === true && unevenskintonecheck === true){
    items.push({
      id: 40394279616572,
      quantity: 1
    },
               {
      id: 40394279649340,
      quantity: 1
    },
               {
      id:40394279190588,
      quantity: 1
    },
               {
      id: 40394279518268,
      quantity: 1
    },
               {
      id: 40394279452732,
      quantity: 1
    }
              )

    $('.container3-sec3').show();
    $('.container1-sec1').hide();
    $('.container2-sec2').hide();
    $('.container4-sec4').hide();
    $('.container5-sec5').hide();
    $('.container6-sec6').hide();
    $('.container7-sec7').hide();
    $('.container8-sec8').hide();
    $('.container81-sec81').hide();
    $('.container9-sec9').hide();
    $('.container10-sec10').hide();
    $('.container11-sec11').hide();
    $('.container12-sec12').hide();
    $('.container13-sec13').hide();
    $('.container14-sec14').hide();
    $('.container15-sec15').hide();
    $('.container16-sec16').hide();
    $('.container17-sec17').hide();

    /*
    var c3i1 = document.getElementById('container3-item1');
    var c3i2 = document.getElementById('container3-item2');
    var c3i3 = document.getElementById('container3-item3');
    var c3i4 = document.getElementById('container3-item4');
    var c3i5 = document.getElementById('container3-item5');

    c3i1.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/mandelaac-FW.jpg?v=1628249957" ></img>';
    c3i1.innerHTML += '<h3 class="mbl-heading-size">MandelAC Facewash</h3>';

    c3i2.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/maxdif-Cream.jpg?v=1628372288" ></img>';
    c3i2.innerHTML += '<h3 class="mbl-heading-size">MAXDIF SKIN BRIGHTENING CREAM</h3>';

    c3i3.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/Dermive-Oil-Free_2_9336c317-339d-4fc0-a5db-dda3ad66786f.jpg?v=1628373012" ></img>';
    c3i3.innerHTML += '<h3 class="mbl-heading-size">Dermive Oil Free</h3>';

    c3i4.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/spectyra-Matt.jpg?v=1628756247" ></img>';
    c3i4.innerHTML += '<h3 class="mbl-heading-size">SPECTRA Matt SC SPF 40</h3>';

    c3i5.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/revivoderm_2.jpg?v=1628372474" ></img>';
    c3i5.innerHTML += '<h3 class="mbl-heading-size">REVIVODERM</h3>';  	
  */

  }
  else if(oilycheck === true && darkspotscheck === true){
    items.push({
      id: 40394279616572,
      quantity: 1
    },
               {
      id: 40394279551036,
      quantity: 1
    },
               {
      id: 40394279649340,
      quantity: 1
    },
               {
      id:40394279190588,
      quantity: 1
    },
               {
      id: 40394279518268,
      quantity: 1
    },
               {
      id: 40394279452732,
      quantity: 1
    }
              )

    $('.container4-sec4').show();
    $('.container1-sec1').hide();
    $('.container2-sec2').hide();
    $('.container3-sec3').hide();
    $('.container5-sec5').hide();
    $('.container6-sec6').hide();
    $('.container7-sec7').hide();
    $('.container8-sec8').hide();
    $('.container81-sec81').hide();
    $('.container9-sec9').hide();
    $('.container10-sec10').hide();
    $('.container11-sec11').hide();
    $('.container12-sec12').hide();
    $('.container13-sec13').hide();
    $('.container14-sec14').hide();
    $('.container15-sec15').hide();
    $('.container16-sec16').hide();
    $('.container17-sec17').hide();


    /*
    var c4i1 = document.getElementById('container4-item1');
    var c4i2 = document.getElementById('container4-item2');
    var c4i3 = document.getElementById('container4-item3');
    var c4i4 = document.getElementById('container4-item4');
    var c4i5 = document.getElementById('container4-item5');
    var c4i6 = document.getElementById('container4-item6');

    c4i1.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/mandelaac-FW.jpg?v=1628249957" ></img>';
    c4i1.innerHTML += '<h3 class="mbl-heading-size">MandelAC Facewash</h3>';

    c4i2.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/Mandelac-Serum_2_0b071a3e-3248-41ff-be3b-24804c281f85.jpg?v=1628373009" ></img>';
    c4i2.innerHTML += '<h3 class="mbl-heading-size">MANDELAC SERUM</h3>';

    c4i3.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/maxdif-Cream.jpg?v=1628372288" ></img>';
    c4i3.innerHTML += '<h3 class="mbl-heading-size">MAXDIF SKIN BRIGHTENING CREAM</h3>';

    c4i4.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/Dermive-Oil-Free_2_9336c317-339d-4fc0-a5db-dda3ad66786f.jpg?v=1628373012" ></img>';
    c4i4.innerHTML += '<h3 class="mbl-heading-size">Dermive Oil Free</h3>';

    c4i5.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/spectyra-Matt.jpg?v=1628756247" ></img>';
    c4i5.innerHTML += '<h3 class="mbl-heading-size">SPECTRA Matt SC SPF 40</h3>';

    c4i6.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/revivoderm_2.jpg?v=1628372474" ></img>';
    c4i6.innerHTML += '<h3 class="mbl-heading-size">REVIVODERM</h3>';  
    */

  }
  else if(oilycheck === true && dulldryskincheck === true){
    items.push({
      id: 40394279616572,
      quantity: 1
    },
               {
      id: 40394279649340,
      quantity: 1
    },
               {
      id:40394279190588,
      quantity: 1
    },
               {
      id: 40394279518268,
      quantity: 1
    })

    $('.container5-sec5').show();
    $('.container1-sec1').hide();
    $('.container2-sec2').hide();
    $('.container3-sec3').hide();
    $('.container4-sec4').hide();
    $('.container6-sec6').hide();
    $('.container7-sec7').hide();
    $('.container8-sec8').hide();
    $('.container81-sec81').hide();
    $('.container9-sec9').hide();
    $('.container10-sec10').hide();
    $('.container11-sec11').hide();
    $('.container12-sec12').hide();
    $('.container13-sec13').hide();
    $('.container14-sec14').hide();
    $('.container15-sec15').hide();
    $('.container16-sec16').hide();
    $('.container17-sec17').hide();

    /*
    var c5i1 = document.getElementById('container5-item1');
    var c5i2 = document.getElementById('container5-item2');
    var c5i3 = document.getElementById('container5-item3');
    var c5i4 = document.getElementById('container5-item4');

    c5i1.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/mandelaac-FW.jpg?v=1628249957" ></img>';
    c5i1.innerHTML += '<h3 class="mbl-heading-size">MandelAC Facewash</h3>';

    c5i2.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/maxdif-Cream.jpg?v=1628372288" ></img>';
    c5i2.innerHTML += '<h3 class="mbl-heading-size">MAXDIF SKIN BRIGHTENING CREAM</h3>';

    c5i3.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/Dermive-Oil-Free_2_9336c317-339d-4fc0-a5db-dda3ad66786f.jpg?v=1628373012" ></img>';
    c5i3.innerHTML += '<h3 class="mbl-heading-size">Dermive Oil Free</h3>';

    c5i4.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/spectyra-Matt.jpg?v=1628756247" ></img>';
    c5i4.innerHTML += '<h3 class="mbl-heading-size">SPECTRA Matt SC SPF 40</h3>';
    */


  }

  //drycheck
  if(drycheck === true && oilinessporescheck === true){
    items.push({
      id: 40394279616572,
      quantity: 1
    },
               {
      id: 40394279551036,
      quantity: 1
    },
               {
      id:40394279190588,
      quantity: 1
    },
               {
      id: 39352889737276,
      quantity: 1
    })


    $('.container6-sec6').show();
    $('.container1-sec1').hide();
    $('.container2-sec2').hide();
    $('.container3-sec3').hide();
    $('.container4-sec4').hide();
    $('.container5-sec5').hide();
    $('.container7-sec7').hide();
    $('.container8-sec8').hide();
    $('.container81-sec81').hide();
    $('.container9-sec9').hide();
    $('.container10-sec10').hide();
    $('.container11-sec11').hide();
    $('.container12-sec12').hide();
    $('.container13-sec13').hide();
    $('.container14-sec14').hide();
    $('.container15-sec15').hide();
    $('.container16-sec16').hide();
    $('.container17-sec17').hide();

    /*
    var c6i1 = document.getElementById('container6-item1');
    var c6i2 = document.getElementById('container6-item2');
    var c6i3 = document.getElementById('container6-item3');
    var c6i4 = document.getElementById('container6-item4');

    c6i1.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/mandelaac-FW.jpg?v=1628249957" ></img>';
    c6i1.innerHTML += '<h3 class="mbl-heading-size">MandelAC Facewash</h3>';

    c6i2.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/Mandelac-Serum_2_0b071a3e-3248-41ff-be3b-24804c281f85.jpg?v=1628373009" ></img>';
    c6i2.innerHTML += '<h3 class="mbl-heading-size">MANDELAC SERUM</h3>';

    c6i3.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/Dermive-Oil-Free_2_9336c317-339d-4fc0-a5db-dda3ad66786f.jpg?v=1628373012" ></img>';
    c6i3.innerHTML += '<h3 class="mbl-heading-size">Dermive Oil Free</h3>';

    c6i4.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/spectra-Block-100_1.jpg?v=1628250094" ></img>';
    c6i4.innerHTML += '<h3 class="mbl-heading-size">SPECTRA BLOCK MAX 100</h3>';
  */


  }
  else if(drycheck === true && acnepimplescheck === true){
    items.push({
      id: 40394279616572,
      quantity: 1
    },
               {
      id: 40394279157820,
      quantity: 1
    },
               {
      id:40394279190588,
      quantity: 1
    },
               {
      id: 39352889737276,
      quantity: 1
    },
               {
      id: 40394279452732,
      quantity: 1
    })

    $('.container7-sec7').show();
    $('.container1-sec1').hide();
    $('.container2-sec2').hide();
    $('.container3-sec3').hide();
    $('.container4-sec4').hide();
    $('.container5-sec5').hide();
    $('.container6-sec6').hide();
    $('.container8-sec8').hide();
    $('.container81-sec81').hide();
    $('.container9-sec9').hide();
    $('.container10-sec10').hide();
    $('.container11-sec11').hide();
    $('.container12-sec12').hide();
    $('.container13-sec13').hide();
    $('.container14-sec14').hide();
    $('.container15-sec15').hide();
    $('.container16-sec16').hide();
    $('.container17-sec17').hide();

    /*
    var c7i1 = document.getElementById('container7-item1');
    var c7i2 = document.getElementById('container7-item2');
    var c7i3 = document.getElementById('container7-item3');
    var c7i4 = document.getElementById('container7-item4');
    var c7i5 = document.getElementById('container7-item5')

    c7i1.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/mandelaac-FW.jpg?v=1628249957" ></img>';
    c7i1.innerHTML += '<h3 class="mbl-heading-size">MandelAC Facewash</h3>';

    c7i2.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/mandelac-Cream_1.jpg?v=1628758681" ></img>';
    c7i2.innerHTML += '<h3 class="mbl-heading-size">MANDELAC CREAM</h3>';

    c7i3.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/Dermive-Oil-Free_2_9336c317-339d-4fc0-a5db-dda3ad66786f.jpg?v=1628373012" ></img>';
    c7i3.innerHTML += '<h3 class="mbl-heading-size">Dermive Oil Free</h3>';

    c7i4.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/spectra-Block-100_1.jpg?v=1628250094" ></img>';
    c7i4.innerHTML += '<h3 class="mbl-heading-size">SPECTRA BLOCK MAX 100</h3>';

    c7i5.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/revivoderm_2.jpg?v=1628372474" ></img>';
    c7i5.innerHTML += '<h3 class="mbl-heading-size">REVIVODERM</h3>';
  */

  }
  else if(drycheck === true && acnescarscheck === true){
    items.push({
      id: 40394279616572,
      quantity: 1
    },
               {
      id: 40394279157820,
      quantity: 1
    },
               {
      id:40394279190588,
      quantity: 1
    },
               {
      id: 39352889737276,
      quantity: 1
    },
               {
      id: 40394279452732,
      quantity: 1
    })


    $('.container7-sec7').show();
    $('.container1-sec1').hide();
    $('.container2-sec2').hide();
    $('.container3-sec3').hide();
    $('.container4-sec4').hide();
    $('.container5-sec5').hide();
    $('.container6-sec6').hide();
    $('.container8-sec8').hide();
    $('.container81-sec81').hide();
    $('.container9-sec9').hide();
    $('.container10-sec10').hide();
    $('.container11-sec11').hide();
    $('.container12-sec12').hide();
    $('.container13-sec13').hide();
    $('.container14-sec14').hide();
    $('.container15-sec15').hide();
    $('.container16-sec16').hide();
    $('.container17-sec17').hide();


    /*
    var c7i1 = document.getElementById('container7-item1');
    var c7i2 = document.getElementById('container7-item2');
    var c7i3 = document.getElementById('container7-item3');
    var c7i4 = document.getElementById('container7-item4');
    var c7i5 = document.getElementById('container7-item5');

    c7i1.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/mandelaac-FW.jpg?v=1628249957" ></img>';
    c7i1.innerHTML += '<h3 class="mbl-heading-size">MandelAC Facewash</h3>';

    c7i2.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/mandelac-Cream_1.jpg?v=1628758681" ></img>';
    c7i2.innerHTML += '<h3 class="mbl-heading-size">MANDELAC CREAM</h3>';

    c7i3.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/Dermive-Oil-Free_2_9336c317-339d-4fc0-a5db-dda3ad66786f.jpg?v=1628373012" ></img>';
    c7i3.innerHTML += '<h3 class="mbl-heading-size">Dermive Oil Free</h3>';

    c7i4.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/spectra-Block-100_1.jpg?v=1628250094" ></img>';
    c7i4.innerHTML += '<h3 class="mbl-heading-size">SPECTRA BLOCK MAX 100</h3>';

    c7i5.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/revivoderm_2.jpg?v=1628372474" ></img>';
    c7i5.innerHTML += '<h3 class="mbl-heading-size">REVIVODERM</h3>';
    */


  }
  else if(drycheck === true && unevenskintonecheck === true){
    items.push({
      id: 40394279616572,
      quantity: 1
    },
               {
      id: 40394279649340,
      quantity: 1
    },
               {
      id:40394279190588,
      quantity: 1
    },
               {
      id: 39352889737276,
      quantity: 1
    },
               {
      id: 40394279452732,
      quantity: 1
    })

    $('.container8-sec8').show();
    $('.container1-sec1').hide();
    $('.container2-sec2').hide();
    $('.container3-sec3').hide();
    $('.container4-sec4').hide();
    $('.container5-sec5').hide();
    $('.container6-sec6').hide();
    $('.container7-sec7').hide();
    $('.container81-sec81').hide();
    $('.container9-sec9').hide();
    $('.container10-sec10').hide();
    $('.container11-sec11').hide();
    $('.container12-sec12').hide();
    $('.container13-sec13').hide();
    $('.container14-sec14').hide();
    $('.container15-sec15').hide();
    $('.container16-sec16').hide();
    $('.container17-sec17').hide();

    /*
    var c8i1 = document.getElementById('container8-item1');
    var c8i2 = document.getElementById('container8-item2');
    var c8i3 = document.getElementById('container8-item3');
    var c8i4 = document.getElementById('container8-item4');
    var c8i5 = document.getElementById('container8-item5');

    c8i1.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/mandelaac-FW.jpg?v=1628249957" ></img>';
    c8i1.innerHTML += '<h3 class="mbl-heading-size">MandelAC Facewash</h3>';

    c8i2.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/maxdif-Cream.jpg?v=1628372288" ></img>';
    c8i2.innerHTML += '<h3 class="mbl-heading-size">MAXDIF SKIN BRIGHTENING CREAM</h3>';

    c8i3.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/Dermive-Oil-Free_2_9336c317-339d-4fc0-a5db-dda3ad66786f.jpg?v=1628373012" ></img>';
    c8i3.innerHTML += '<h3 class="mbl-heading-size">Dermive Oil Free</h3>';

    c8i4.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/spectra-Block-100_1.jpg?v=1628250094" ></img>';
    c8i4.innerHTML += '<h3 class="mbl-heading-size">SPECTRA BLOCK MAX 100</h3>';

    c8i5.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/revivoderm_2.jpg?v=1628372474" ></img>';
    c8i5.innerHTML += '<h3 class="mbl-heading-size">REVIVODERM</h3>';

    */

  }
  else if(drycheck === true && darkspotscheck === true){
    items.push({
      id: 40394279616572,
      quantity: 1
    },
               {
      id: 40394279649340,
      quantity: 1
    },
               {
      id:40394279190588,
      quantity: 1
    },
               {
      id: 39352889737276,
      quantity: 1
    },
               {
      id: 40394279452732,
      quantity: 1
    })


    $('.container8-sec8').show();
    $('.container1-sec1').hide();
    $('.container2-sec2').hide();
    $('.container3-sec3').hide();
    $('.container4-sec4').hide();
    $('.container5-sec5').hide();
    $('.container6-sec6').hide();
    $('.container7-sec7').hide();
    $('.container81-sec81').hide();
    $('.container9-sec9').hide();
    $('.container10-sec10').hide();
    $('.container11-sec11').hide();
    $('.container12-sec12').hide();
    $('.container13-sec13').hide();
    $('.container14-sec14').hide();
    $('.container15-sec15').hide();
    $('.container16-sec16').hide();
    $('.container17-sec17').hide();

    /*
    var c8i1 = document.getElementById('container8-item1');
    var c8i2 = document.getElementById('container8-item2');
    var c8i3 = document.getElementById('container8-item3');
    var c8i4 = document.getElementById('container8-item4');
    var c8i5 = document.getElementById('container8-item5');

    c8i1.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/mandelaac-FW.jpg?v=1628249957" ></img>';
    c8i1.innerHTML += '<h3 class="mbl-heading-size">MandelAC Facewash</h3>';

    c8i2.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/maxdif-Cream.jpg?v=1628372288" ></img>';
    c8i2.innerHTML += '<h3 class="mbl-heading-size">MAXDIF SKIN BRIGHTENING CREAM</h3>';

    c8i3.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/Dermive-Oil-Free_2_9336c317-339d-4fc0-a5db-dda3ad66786f.jpg?v=1628373012" ></img>';
    c8i3.innerHTML += '<h3 class="mbl-heading-size">Dermive Oil Free</h3>';

    c8i4.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/spectra-Block-100_1.jpg?v=1628250094" ></img>';
    c8i4.innerHTML += '<h3 class="mbl-heading-size">SPECTRA BLOCK MAX 100</h3>';

    c8i5.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/revivoderm_2.jpg?v=1628372474" ></img>';
    c8i5.innerHTML += '<h3 class="mbl-heading-size">REVIVODERM</h3>';
   */


  }
  else if(drycheck === true && dulldryskincheck === true){
    items.push({
      id: 40394279616572,
      quantity: 1
    },
               {
      id: 40394279649340,
      quantity: 1
    },
               {
      id:40394279190588,
      quantity: 1
    },
               {
      id: 39352889737276,
      quantity: 1
    },
               {
      id: 40394279452732,
      quantity: 1
    })


    $('.container81-sec81').show();
    $('.container1-sec1').hide();
    $('.container2-sec2').hide();
    $('.container3-sec3').hide();
    $('.container4-sec4').hide();
    $('.container5-sec5').hide();
    $('.container6-sec6').hide();
    $('.container7-sec7').hide();
    $('.container8-sec8').hide();
    $('.container9-sec9').hide();
    $('.container10-sec10').hide();
    $('.container11-sec11').hide();
    $('.container12-sec12').hide();
    $('.container13-sec13').hide();
    $('.container14-sec14').hide();
    $('.container15-sec15').hide();
    $('.container16-sec16').hide();
    $('.container17-sec17').hide();


    /*
    var c8i1 = document.getElementById('container8-item1');
    var c8i2 = document.getElementById('container8-item2');
    var c8i3 = document.getElementById('container8-item3');
    var c8i4 = document.getElementById('container8-item4');
    var c8i5 = document.getElementById('container8-item5');

    c8i1.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/mandelaac-FW.jpg?v=1628249957" ></img>';
    c8i1.innerHTML += '<h3 class="mbl-heading-size">MandelAC Facewash</h3>';

    c8i2.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/maxdif-Cream.jpg?v=1628372288" ></img>';
    c8i2.innerHTML += '<h3 class="mbl-heading-size">MAXDIF SKIN BRIGHTENING CREAM</h3>';

    c8i3.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/Dermive-Oil-Free_2_9336c317-339d-4fc0-a5db-dda3ad66786f.jpg?v=1628373012" ></img>';
    c8i3.innerHTML += '<h3 class="mbl-heading-size">Dermive Oil Free</h3>';

    c8i4.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/spectra-Block-100_1.jpg?v=1628250094" ></img>';
    c8i4.innerHTML += '<h3 class="mbl-heading-size">SPECTRA BLOCK MAX 100</h3>';

    c8i5.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/revivoderm_2.jpg?v=1628372474" ></img>';
    c8i5.innerHTML += '<h3 class="mbl-heading-size">REVIVODERM</h3>';
      */


  }

  //normalcheck
  if(normalcheck === true && oilinessporescheck === true){
    items.push({
      id: 40394279616572,
      quantity: 1
    },
               {
      id: 40394279551036,
      quantity: 1
    },
               {
      id:40394279190588,
      quantity: 1
    },
               {
      id: 40394279485500,
      quantity: 1
    },
               {
      id: 40394279452732,
      quantity: 1
    })

    $('.container9-sec9').show();
    $('.container1-sec1').hide();
    $('.container2-sec2').hide();
    $('.container3-sec3').hide();
    $('.container4-sec4').hide();
    $('.container5-sec5').hide();
    $('.container6-sec6').hide();
    $('.container7-sec7').hide();
    $('.container8-sec8').hide();
    $('.container81-sec81').hide();
    $('.container10-sec10').hide();
    $('.container11-sec11').hide();
    $('.container12-sec12').hide();
    $('.container13-sec13').hide();
    $('.container14-sec14').hide();
    $('.container15-sec15').hide();
    $('.container16-sec16').hide();
    $('.container17-sec17').hide();


    /*
    var c9i1 = document.getElementById('container9-item1');
    var c9i2 = document.getElementById('container9-item2');
    var c9i3 = document.getElementById('container9-item3');
    var c9i4 = document.getElementById('container9-item4');
    var c9i5 = document.getElementById('container9-item5');

    c9i1.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/mandelaac-FW.jpg?v=1628249957" ></img>';
    c9i1.innerHTML += '<h3 class="mbl-heading-size">MandelAC Facewash</h3>';

    c9i2.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/Mandelac-Serum_2_0b071a3e-3248-41ff-be3b-24804c281f85.jpg?v=1628373009" ></img>';
    c9i2.innerHTML += '<h3 class="mbl-heading-size">MANDELAC SERUM</h3>';

    c9i3.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/Dermive-Oil-Free_2_9336c317-339d-4fc0-a5db-dda3ad66786f.jpg?v=1628373012" ></img>';
    c9i3.innerHTML += '<h3 class="mbl-heading-size">Dermive Oil Free</h3>';

    c9i4.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/SPECTRA-bLOCK-60.jpg?v=1628373022" ></img>';
    c9i4.innerHTML += '<h3 class="mbl-heading-size">SPECTRABLOCK SPF60</h3>';

    c9i5.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/revivoderm_2.jpg?v=1628372474" ></img>';
    c9i5.innerHTML += '<h3 class="mbl-heading-size">REVIVODERM</h3>';
    */

  }
  else if(normalcheck === true && acnepimplescheck === true){
    items.push({
      id: 40394279616572,
      quantity: 1
    },
               {
      id: 40394279551036,
      quantity: 1
    },
               {
      id:40394279190588,
      quantity: 1
    },
               {
      id: 40394279485500,
      quantity: 1
    },
               {
      id: 40394279452732,
      quantity: 1
    })


    $('.container9-sec9').show();
    $('.container1-sec1').hide();
    $('.container2-sec2').hide();
    $('.container3-sec3').hide();
    $('.container4-sec4').hide();
    $('.container5-sec5').hide();
    $('.container6-sec6').hide();
    $('.container7-sec7').hide();
    $('.container8-sec8').hide();
    $('.container81-sec81').hide();
    $('.container10-sec10').hide();
    $('.container11-sec11').hide();
    $('.container12-sec12').hide();
    $('.container13-sec13').hide();
    $('.container14-sec14').hide();
    $('.container15-sec15').hide();
    $('.container16-sec16').hide();
    $('.container17-sec17').hide();


    /*
    var c9i1 = document.getElementById('container9-item1');
    var c9i2 = document.getElementById('container9-item2');
    var c9i3 = document.getElementById('container9-item3');
    var c9i4 = document.getElementById('container9-item4');
    var c9i5 = document.getElementById('container9-item5');

    c9i1.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/mandelaac-FW.jpg?v=1628249957" ></img>';
    c9i1.innerHTML += '<h3 class="mbl-heading-size">MandelAC Facewash</h3>';

    c9i2.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/Mandelac-Serum_2_0b071a3e-3248-41ff-be3b-24804c281f85.jpg?v=1628373009" ></img>';
    c9i2.innerHTML += '<h3 class="mbl-heading-size">MANDELAC SERUM</h3>';

    c9i3.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/Dermive-Oil-Free_2_9336c317-339d-4fc0-a5db-dda3ad66786f.jpg?v=1628373012" ></img>';
    c9i3.innerHTML += '<h3 class="mbl-heading-size">Dermive Oil Free</h3>';

    c9i4.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/SPECTRA-bLOCK-60.jpg?v=1628373022" ></img>';
    c9i4.innerHTML += '<h3 class="mbl-heading-size">SPECTRABLOCK SPF60</h3>';

    c9i5.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/revivoderm_2.jpg?v=1628372474" ></img>';
    c9i5.innerHTML += '<h3 class="mbl-heading-size">REVIVODERM</h3>';
    */

  }
  else if(normalcheck === true && acnescarscheck === true){
    items.push({
      id: 40394279616572,
      quantity: 1
    },
               {
      id: 40394279551036,
      quantity: 1
    },
               {
      id:40394279190588,
      quantity: 1
    },
               {
      id: 40394279485500,
      quantity: 1
    },
               {
      id: 40394279452732,
      quantity: 1
    })


    $('.container9-sec9').show();
    $('.container1-sec1').hide();
    $('.container2-sec2').hide();
    $('.container3-sec3').hide();
    $('.container4-sec4').hide();
    $('.container5-sec5').hide();
    $('.container6-sec6').hide();
    $('.container7-sec7').hide();
    $('.container8-sec8').hide();
    $('.container81-sec81').hide();
    $('.container10-sec10').hide();
    $('.container11-sec11').hide();
    $('.container12-sec12').hide();
    $('.container13-sec13').hide();
    $('.container14-sec14').hide();
    $('.container15-sec15').hide();
    $('.container16-sec16').hide();
    $('.container17-sec17').hide();


    /*
    var c9i1 = document.getElementById('container9-item1');
    var c9i2 = document.getElementById('container9-item2');
    var c9i3 = document.getElementById('container9-item3');
    var c9i4 = document.getElementById('container9-item4');
    var c9i5 = document.getElementById('container9-item5');

    c9i1.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/mandelaac-FW.jpg?v=1628249957" ></img>';
    c9i1.innerHTML += '<h3 class="mbl-heading-size">MandelAC Facewash</h3>';

    c9i2.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/Mandelac-Serum_2_0b071a3e-3248-41ff-be3b-24804c281f85.jpg?v=1628373009" ></img>';
    c9i2.innerHTML += '<h3 class="mbl-heading-size">MANDELAC SERUM</h3>';

    c9i3.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/Dermive-Oil-Free_2_9336c317-339d-4fc0-a5db-dda3ad66786f.jpg?v=1628373012" ></img>';
    c9i3.innerHTML += '<h3 class="mbl-heading-size">Dermive Oil Free</h3>';

    c9i4.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/SPECTRA-bLOCK-60.jpg?v=1628373022" ></img>';
    c9i4.innerHTML += '<h3 class="mbl-heading-size">SPECTRABLOCK SPF60</h3>';

    c9i5.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/revivoderm_2.jpg?v=1628372474" ></img>';
    c9i5.innerHTML += '<h3 class="mbl-heading-size">REVIVODERM</h3>';
    */

  }
  else if(normalcheck === true && unevenskintonecheck === true){
    items.push({
      id: 40394279911484,
      quantity: 1
    },
               {
      id: 40394279649340,
      quantity: 1
    },
               {
      id:40394279190588,
      quantity: 1
    },
               {
      id: 40394279485500,
      quantity: 1
    },
               {
      id: 40394279452732,
      quantity: 1
    })

    $('.container10-sec10').show();
    $('.container1-sec1').hide();
    $('.container2-sec2').hide();
    $('.container3-sec3').hide();
    $('.container4-sec4').hide();
    $('.container5-sec5').hide();
    $('.container6-sec6').hide();
    $('.container7-sec7').hide();
    $('.container8-sec8').hide();
    $('.container81-sec81').hide();
    $('.container9-sec9').hide();
    $('.container11-sec11').hide();
    $('.container12-sec12').hide();
    $('.container13-sec13').hide();
    $('.container14-sec14').hide();
    $('.container15-sec15').hide();
    $('.container16-sec16').hide();
    $('.container17-sec17').hide();



    /*
    var c10i1 = document.getElementById('container10-item1');
    var c10i2 = document.getElementById('container10-item2');
    var c10i3 = document.getElementById('container10-item3');
    var c10i4 = document.getElementById('container10-item4');
    var c10i5 = document.getElementById('container10-item5');

    c10i1.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/maxdif-Fw_1.jpg?v=1628372292" ></img>';
    c10i1.innerHTML += '<h3 class="mbl-heading-size">MAXDIF FACEWASH</h3>';

    c10i2.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/maxdif-Cream.jpg?v=1628372288" ></img>';
    c10i2.innerHTML += '<h3 class="mbl-heading-size">MAXDIF SKIN BRIGHTENING CREAM</h3>';

    c10i3.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/Dermive-Oil-Free_2_9336c317-339d-4fc0-a5db-dda3ad66786f.jpg?v=1628373012" ></img>';
    c10i3.innerHTML += '<h3 class="mbl-heading-size">Dermive Oil Free</h3>';

    c10i4.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/SPECTRA-bLOCK-60.jpg?v=1628373022" ></img>';
    c10i4.innerHTML += '<h3 class="mbl-heading-size">SPECTRABLOCK SPF60</h3>';

    c10i5.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/revivoderm_2.jpg?v=1628372474" ></img>';
    c10i5.innerHTML += '<h3 class="mbl-heading-size">REVIVODERM</h3>';
    */

  }
  else if(normalcheck === true && darkspotscheck === true){
    items.push({
      id: 40394279911484,
      quantity: 1
    },
               {
      id: 40394279649340,
      quantity: 1
    },
               {
      id:40394279190588,
      quantity: 1
    },
               {
      id: 40394279485500,
      quantity: 1
    },
               {
      id: 40394279452732,
      quantity: 1
    })


    $('.container11-sec11').show();
    $('.container1-sec1').hide();
    $('.container2-sec2').hide();
    $('.container3-sec3').hide();
    $('.container4-sec4').hide();
    $('.container5-sec5').hide();
    $('.container6-sec6').hide();
    $('.container7-sec7').hide();
    $('.container8-sec8').hide();
    $('.container81-sec81').hide();
    $('.container9-sec9').hide();
    $('.container10-sec10').hide();
    $('.container12-sec12').hide();
    $('.container13-sec13').hide();
    $('.container14-sec14').hide();
    $('.container15-sec15').hide();
    $('.container16-sec16').hide();
    $('.container17-sec17').hide();



    /*
    var c11i1 = document.getElementById('container11-item1');
    var c11i2 = document.getElementById('container11-item2');
    var c11i3 = document.getElementById('container11-item3');
    var c11i4 = document.getElementById('container11-item4');
    var c11i5 = document.getElementById('container11-item5');
    var c11i6 = document.getElementById('container11-item6');

    c11i1.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/maxdif-Fw_1.jpg?v=1628372292" ></img>';
    c11i1.innerHTML += '<h3 class="mbl-heading-size">MAXDIF FACEWASH</h3>';

    c11i2.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/maxdif-Cream.jpg?v=1628372288" ></img>';
    c11i2.innerHTML += '<h3 class="mbl-heading-size">MAXDIF SKIN BRIGHTENING CREAM</h3>';

    c11i3.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/Mandelac-Serum_2_0b071a3e-3248-41ff-be3b-24804c281f85.jpg?v=1628373009" ></img>';
    c11i3.innerHTML += '<h3 class="mbl-heading-size">MANDELAC SERUM</h3>';

    c11i4.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/Dermive-Oil-Free_2_9336c317-339d-4fc0-a5db-dda3ad66786f.jpg?v=1628373012" ></img>';
    c11i4.innerHTML += '<h3 class="mbl-heading-size">Dermive Oil Free</h3>';

    c11i5.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/SPECTRA-bLOCK-60.jpg?v=1628373022" ></img>';
    c11i5.innerHTML += '<h3 class="mbl-heading-size">SPECTRABLOCK SPF60</h3>';

    c11i6.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/revivoderm_2.jpg?v=1628372474" ></img>';
    c11i6.innerHTML += '<h3 class="mbl-heading-size">REVIVODERM</h3>';
    */

  }
  else if(normalcheck === true && dulldryskincheck === true){
    items.push({
      id: 40394279616572,
      quantity: 1
    },
               {
      id: 40394279649340,
      quantity: 1
    },
               {
      id:40394279190588,
      quantity: 1
    },
               {
      id: 40394279485500,
      quantity: 1
    },
               {
      id: 40394279452732,
      quantity: 1
    })

    $('.container12-sec12').show();
    $('.container1-sec1').hide();
    $('.container2-sec2').hide();
    $('.container3-sec3').hide();
    $('.container4-sec4').hide();
    $('.container5-sec5').hide();
    $('.container6-sec6').hide();
    $('.container7-sec7').hide();
    $('.container8-sec8').hide();
    $('.container81-sec81').hide();
    $('.container9-sec9').hide();
    $('.container10-sec10').hide();
    $('.container11-sec11').hide();
    $('.container13-sec13').hide();
    $('.container14-sec14').hide();
    $('.container15-sec15').hide();
    $('.container16-sec16').hide();
    $('.container17-sec17').hide();




    /*
    var c12i1 = document.getElementById('container12-item1');
    var c12i2 = document.getElementById('container12-item2');
    var c12i3 = document.getElementById('container12-item3');
    var c12i4 = document.getElementById('container12-item4');
    var c12i5 = document.getElementById('container12-item5');

    c12i1.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/mandelaac-FW.jpg?v=1628249957" ></img>' ;
    c12i1.innerHTML += '<h3 class="mbl-heading-size">MandelAC Facewash</h3>';

    c12i2.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/maxdif-Cream.jpg?v=1628372288" ></img>';
    c12i2.innerHTML += '<h3 class="mbl-heading-size">MAXDIF SKIN BRIGHTENING CREAM</h3>';

    c12i3.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/Dermive-Oil-Free_2_9336c317-339d-4fc0-a5db-dda3ad66786f.jpg?v=1628373012" ></img>';
    c12i3.innerHTML += '<h3 class="mbl-heading-size">Dermive Oil Free</h3>';

    c12i4.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/SPECTRA-bLOCK-60.jpg?v=1628373022" ></img>';
    c12i4.innerHTML += '<h3 class="mbl-heading-size">SPECTRABLOCK SPF60</h3>';

    c12i5.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/revivoderm_2.jpg?v=1628372474" ></img>';
    c12i5.innerHTML += '<h3 class="mbl-heading-size">REVIVODERM</h3>';
    */

  }

  //combination
  if(combinationcheck === true && oilinessporescheck === true){
    items.push({
      id: 40394279616572,
      quantity: 1
    },
               {
      id: 40394279551036,
      quantity: 1
    },
               {
      id:40394279190588,
      quantity: 1
    },
               {
      id: 40394279518268,
      quantity: 1
    })


    $('.container13-sec13').show();
    $('.container1-sec1').hide();
    $('.container2-sec2').hide();
    $('.container3-sec3').hide();
    $('.container4-sec4').hide();
    $('.container5-sec5').hide();
    $('.container6-sec6').hide();
    $('.container7-sec7').hide();
    $('.container8-sec8').hide();
    $('.container81-sec81').hide();
    $('.container9-sec9').hide();
    $('.container10-sec10').hide();
    $('.container11-sec11').hide();
    $('.container12-sec12').hide();
    $('.container14-sec14').hide();
    $('.container15-sec15').hide();
    $('.container16-sec16').hide();
    $('.container17-sec17').hide();

    /*
    var c13i1 = document.getElementById('container13-item1');
    var c13i2 = document.getElementById('container13-item2');
    var c13i3 = document.getElementById('container13-item3');
    var c13i4 = document.getElementById('container13-item4');

    c13i1.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/mandelaac-FW.jpg?v=1628249957" ></img>' ;
    c13i1.innerHTML += '<h3 class="mbl-heading-size">MandelAC Facewash</h3>';

    c13i2.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/Mandelac-Serum_2_0b071a3e-3248-41ff-be3b-24804c281f85.jpg?v=1628373009" ></img>';
    c13i2.innerHTML += '<h3 class="mbl-heading-size">MANDELAC SERUM</h3>';

    c13i3.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/Dermive-Oil-Free_2_9336c317-339d-4fc0-a5db-dda3ad66786f.jpg?v=1628373012" ></img>';
    c13i3.innerHTML += '<h3 class="mbl-heading-size">Dermive Oil Free</h3>';

    c13i4.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/spectyra-Matt.jpg?v=1628756247" ></img>';
    c13i4.innerHTML += '<h3 class="mbl-heading-size">SPECTRA Matt SC SPF 40</h3>';
    */

  }
  else if(combinationcheck === true && acnepimplescheck === true){
    items.push({
      id: 40394279616572,
      quantity: 1
    },
               {
      id: 40394279551036,
      quantity: 1
    },
               {
      id:40394279190588,
      quantity: 1
    },
               {
      id: 40394279518268,
      quantity: 1
    },
               {
      id: 40394279452732,
      quantity: 1
    })


    $('.container14-sec14').show();
    $('.container1-sec1').hide();
    $('.container2-sec2').hide();
    $('.container3-sec3').hide();
    $('.container4-sec4').hide();
    $('.container5-sec5').hide();
    $('.container6-sec6').hide();
    $('.container7-sec7').hide();
    $('.container8-sec8').hide();
    $('.container81-sec81').hide();
    $('.container9-sec9').hide();
    $('.container10-sec10').hide();
    $('.container11-sec11').hide();
    $('.container12-sec12').hide();
    $('.container13-sec13').hide();
    $('.container15-sec15').hide();
    $('.container16-sec16').hide();
    $('.container17-sec17').hide();


    /*
    var c14i1 = document.getElementById('container14-item1');
    var c14i2 = document.getElementById('container14-item2');
    var c14i3 = document.getElementById('container14-item3');
    var c14i4 = document.getElementById('container14-item4');
    var c14i5 = document.getElementById('container14-item5');

    c14i1.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/mandelaac-FW.jpg?v=1628249957" ></img>' ;
    c14i1.innerHTML += '<h3 class="mbl-heading-size">MandelAC Facewash</h3>';

    c14i2.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/Mandelac-Serum_2_0b071a3e-3248-41ff-be3b-24804c281f85.jpg?v=1628373009" ></img>';
    c14i2.innerHTML += '<h3 class="mbl-heading-size">MANDELAC SERUM</h3>';

    c14i3.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/Dermive-Oil-Free_2_9336c317-339d-4fc0-a5db-dda3ad66786f.jpg?v=1628373012" ></img>';
    c14i3.innerHTML += '<h3 class="mbl-heading-size">Dermive Oil Free</h3>';

    c14i4.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/spectyra-Matt.jpg?v=1628756247" ></img>';
    c14i4.innerHTML += '<h3 class="mbl-heading-size">SPECTRA Matt SC SPF 40</h3>';

    c14i5.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/revivoderm_2.jpg?v=1628372474" ></img>';
    c14i5.innerHTML += '<h3 class="mbl-heading-size">REVIVODERM</h3>';
    */

  }
  else if(combinationcheck === true && acnescarscheck === true){
    items.push({
      id: 40394279616572,
      quantity: 1
    },
               {
      id: 40394279551036,
      quantity: 1
    },
               {
      id:40394279190588,
      quantity: 1
    },
               {
      id: 40394279518268,
      quantity: 1
    },
               {
      id: 40394279452732,
      quantity: 1
    })


    $('.container14-sec14').show();
    $('.container1-sec1').hide();
    $('.container2-sec2').hide();
    $('.container3-sec3').hide();
    $('.container4-sec4').hide();
    $('.container5-sec5').hide();
    $('.container6-sec6').hide();
    $('.container7-sec7').hide();
    $('.container8-sec8').hide();
    $('.container81-sec81').hide();
    $('.container9-sec9').hide();
    $('.container10-sec10').hide();
    $('.container11-sec11').hide();
    $('.container12-sec12').hide();
    $('.container13-sec13').hide();
    $('.container15-sec15').hide();
    $('.container16-sec16').hide();
    $('.container17-sec17').hide();

    /*
    var c14i1 = document.getElementById('container14-item1');
    var c14i2 = document.getElementById('container14-item2');
    var c14i3 = document.getElementById('container14-item3');
    var c14i4 = document.getElementById('container14-item4');
    var c14i5 = document.getElementById('container14-item5');

    c14i1.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/mandelaac-FW.jpg?v=1628249957" ></img>' ;
    c14i1.innerHTML += '<h3 class="mbl-heading-size">MandelAC Facewash</h3>';

    c14i2.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/Mandelac-Serum_2_0b071a3e-3248-41ff-be3b-24804c281f85.jpg?v=1628373009" ></img>';
    c14i2.innerHTML += '<h3 class="mbl-heading-size">MANDELAC SERUM</h3>';

    c14i3.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/Dermive-Oil-Free_2_9336c317-339d-4fc0-a5db-dda3ad66786f.jpg?v=1628373012" ></img>';
    c14i3.innerHTML += '<h3 class="mbl-heading-size">Dermive Oil Free</h3>';

    c14i4.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/spectyra-Matt.jpg?v=1628756247" ></img>';
    c14i4.innerHTML += '<h3 class="mbl-heading-size">SPECTRA Matt SC SPF 40</h3>';

    c14i5.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/revivoderm_2.jpg?v=1628372474" ></img>';
    c14i5.innerHTML += '<h3 class="mbl-heading-size">REVIVODERM</h3>';
    */

  }
  else if(combinationcheck === true && unevenskintonecheck === true){
    items.push({
      id: 40394279911484,
      quantity: 1
    },
               {
      id: 40394279649340,
      quantity: 1
    },
               {
      id:40394279190588,
      quantity: 1
    },
               {
      id: 39352889737276,
      quantity: 1
    },
               {
      id: 40394279452732,
      quantity: 1
    })

    $('.container15-sec15').show();
    $('.container1-sec1').hide();
    $('.container2-sec2').hide();
    $('.container3-sec3').hide();
    $('.container4-sec4').hide();
    $('.container5-sec5').hide();
    $('.container6-sec6').hide();
    $('.container7-sec7').hide();
    $('.container8-sec8').hide();
    $('.container81-sec81').hide();
    $('.container9-sec9').hide();
    $('.container10-sec10').hide();
    $('.container11-sec11').hide();
    $('.container12-sec12').hide();
    $('.container13-sec13').hide();
    $('.container14-sec14').hide();
    $('.container16-sec16').hide();
    $('.container17-sec17').hide();


    /*    
    var c15i1 = document.getElementById('container15-item1');
    var c15i2 = document.getElementById('container15-item2');
    var c15i3 = document.getElementById('container15-item3');
    var c15i4 = document.getElementById('container15-item4');
    var c15i5 = document.getElementById('container15-item5');

    c15i1.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/maxdif-Fw_1.jpg?v=1628372292" ></img>';
    c15i1.innerHTML += '<h3 class="mbl-heading-size">MAXDIF FACEWASH</h3>';

    c15i2.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/maxdif-Cream.jpg?v=1628372288" ></img>';
    c15i2.innerHTML += '<h3 class="mbl-heading-size">MAXDIF SKIN BRIGHTENING CREAM</h3>';

    c15i3.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/Dermive-Oil-Free_2_9336c317-339d-4fc0-a5db-dda3ad66786f.jpg?v=1628373012" ></img>';
    c15i3.innerHTML += '<h3 class="mbl-heading-size">Dermive Oil Free</h3>';

    c15i4.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/spectra-Block-100_1.jpg?v=1628250094" ></img>';
    c15i4.innerHTML += '<h3 class="mbl-heading-size">SPECTRA BLOCK MAX 100</h3>';

    c15i5.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/revivoderm_2.jpg?v=1628372474" ></img>';
    c15i5.innerHTML += '<h3 class="mbl-heading-size">REVIVODERM</h3>';
    */

  }
  else if(combinationcheck === true && darkspotscheck === true){
    items.push({
      id: 40394279616572,
      quantity: 1
    },
               {
      id: 40394279649340,
      quantity: 1
    },
               {
      id: 40394279551036,
      quantity: 1
    },
               {
      id:40394279190588,
      quantity: 1
    },
               {
      id: 40394279485500,
      quantity: 1
    },
               {
      id: 40394279452732,
      quantity: 1
    })


    $('.container16-sec16').show();
    $('.container1-sec1').hide();
    $('.container2-sec2').hide();
    $('.container3-sec3').hide();
    $('.container4-sec4').hide();
    $('.container5-sec5').hide();
    $('.container6-sec6').hide();
    $('.container7-sec7').hide();
    $('.container8-sec8').hide();
    $('.container81-sec81').hide();
    $('.container9-sec9').hide();
    $('.container10-sec10').hide();
    $('.container11-sec11').hide();
    $('.container12-sec12').hide();
    $('.container13-sec13').hide();
    $('.container14-sec14').hide();
    $('.container15-sec15').hide();
    $('.container17-sec17').hide();

    /*
    var c16i1 = document.getElementById('container16-item1');
    var c16i2 = document.getElementById('container16-item2');
    var c16i3 = document.getElementById('container16-item3');
    var c16i4 = document.getElementById('container16-item4');
    var c16i5 = document.getElementById('container16-item5');
    var c16i6 = document.getElementById('container16-item6');

    c16i1.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/mandelaac-FW.jpg?v=1628249957" ></img>';
    c16i1.innerHTML += '<h3 class="mbl-heading-size">MandelAC Facewash</h3>';

    c16i2.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/maxdif-Cream.jpg?v=1628372288" ></img>';
    c16i2.innerHTML += '<h3 class="mbl-heading-size">MAXDIF SKIN BRIGHTENING CREAM</h3>';

    c16i3.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/Mandelac-Serum_2_0b071a3e-3248-41ff-be3b-24804c281f85.jpg?v=1628373009" ></img>';
    c16i3.innerHTML += '<h3 class="mbl-heading-size">MANDELAC SERUM</h3>';

    c16i4.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/Dermive-Oil-Free_2_9336c317-339d-4fc0-a5db-dda3ad66786f.jpg?v=1628373012" ></img>';
    c16i4.innerHTML += '<h3 class="mbl-heading-size">Dermive Oil Free</h3>';

    c16i5.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/SPECTRA-bLOCK-60.jpg?v=1628373022" ></img>';
    c16i5.innerHTML += '<h3 class="mbl-heading-size">SPECTRABLOCK SPF60</h3>';

    c16i6.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0288/8459/8844/files/revivoderm_2.jpg?v=1628372474" ></img>';
    c16i6.innerHTML += '<h3 class="mbl-heading-size">REVIVODERM</h3>';
    */

  }
  else if(combinationcheck === true && dulldryskincheck === true){
    items.push({
      id: 40394279616572,
      quantity: 1
    },
               {
      id: 40394279649340,
      quantity: 1
    },
               {
      id:40394279190588,
      quantity: 1
    },
               {
      id: 39352889737276,
      quantity: 1
    },
               {
      id: 40394279452732,
      quantity: 1
    })


    $('.container17-sec17').show();
    $('.container1-sec1').hide();
    $('.container2-sec2').hide();
    $('.container3-sec3').hide();
    $('.container4-sec4').hide();
    $('.container5-sec5').hide();
    $('.container6-sec6').hide();
    $('.container7-sec7').hide();
    $('.container8-sec8').hide();
    $('.container81-sec81').hide();
    $('.container9-sec9').hide();
    $('.container10-sec10').hide();
    $('.container11-sec11').hide();
    $('.container12-sec12').hide();
    $('.container13-sec13').hide();
    $('.container14-sec14').hide();
    $('.container15-sec15').hide();
    $('.container16-sec16').hide();

  }
  else if(el.value == 'removebtn4' ){
    items = items.filter(item => item.id != "40394279518268");
    console.log(items);
  }
}  

function addItemsToCart(){

  var newitems = [];
  $.each(items, function(key, value) {
    var exists = false;
    $.each(newitems, function(k, val2) {
      if(value.id == val2.id){ exists = true }; 
    });
    if(exists == false && value.id != "") { newitems.push(value); }
  });
  console.log(items);
  $('.loading-modal').show();

  $.post('/cart/add.js', {
    items: newitems
  })
  .done(function() {
    console.log( "success" );
    $('.loading-modal').hide();
  })
  .fail(function() {
    console.log( "error" );
    $('.loading-modal').hide();
  })
  .always(function(data) {
    console.info('finished',JSON.parse(data.responseText));
    window.location.href = 'https://jenpharm.com/cart';
  });
}